export const BodyElements = [
    { key: '1', text: 'viso' },
    { key: '2', text: 'cervicale' },
    { key: '3', text: 'spalla sx' },
    { key: '4', text: 'spalla dx' },
    { key: '5', text: 'respirazione' },
    { key: '6', text: 'gomito sx' },
    { key: '7', text: 'gomito dx' },
    { key: '8', text: 'colonna' },
    { key: '9', text: 'polso sx' },
    { key: '10', text: 'polso dx' },
    { key: '11', text: 'anca sx' },
    { key: '12', text: 'anca dx' },
    { key: '13', text: 'pavimento pelvico' },
    { key: '14', text: 'mano sx' },
    { key: '15', text: 'mano dx' },
    { key: '16', text: 'gamba sx' },
    { key: '17', text: 'gamba dx' },
    { key: '18', text: 'ginocchio sx' },
    { key: '19', text: 'ginocchio dx' },
    { key: '20', text: 'caviglia sx' },
    { key: '21', text: 'caviglia dx' },
    { key: '22', text: 'piede sx' },
    { key: '23', text: 'piede dx' },
    { key: '24', text: 'tutto il corpo' }
];
